(window as any).global = window;
import '../node_modules/event-source-polyfill/src/eventsource.js'
